import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
var __default__ = defineComponent({
  head: {}
});
import { useTrpc } from '~/composables/_next/useTrpc';
import { useGetTranslations } from '~/composables/useGetTranslations';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useSegment } from '~/composables/_next/useSegment';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import RelatedProductsOrganism from '~/components/_next/organisms/RelatedProductsOrganism.vue';
import RelatedRecipesOrganism from '~/components/_next/organisms/RelatedRecipesOrganism.vue';
import RelatedAdvicesOrganism from '~/components/_next/organisms/RelatedAdvicesOrganism.vue';
import { cacheControl } from '~/helpers/cacheControl';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
      ],tracking: {
        category: TrackingPageCategory.CATEGORY
      }
}
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  ...__nuxt_page_meta,__name: 'GenericCategory',
  setup: function setup(__props) {
    var OurSelectionGraphql = function OurSelectionGraphql() {
      return import('~/components/Molecules/OurSelectionGraphql.vue');
    };
    var GenericCategoryItemGraphql = function GenericCategoryItemGraphql() {
      return import('~/components/Molecules/GenericCategoryItemGraphql.vue');
    };
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      error = _useNuxt2App.error,
      app = _useNuxt2App.app;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta,
      getMeta = _useLegacySeoMeta.getMeta;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var contentResource = useState('category-content-resource', function () {
      return null;
    });
    ;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.CATEGORY, PageTypes.CATEGORY);
    });
    var pageGenericCategoryCollection = computed(function () {
      var _contentResource$valu, _contentResource$valu2, _contentResource$valu3;
      return contentResource === null || contentResource === void 0 ? void 0 : (_contentResource$valu = contentResource.value) === null || _contentResource$valu === void 0 ? void 0 : (_contentResource$valu2 = _contentResource$valu.data) === null || _contentResource$valu2 === void 0 ? void 0 : (_contentResource$valu3 = _contentResource$valu2.pageGenericCategoryCollection) === null || _contentResource$valu3 === void 0 ? void 0 : _contentResource$valu3.items[0];
    });
    var description = computed(function () {
      var _pageGenericCategoryC;
      return (pageGenericCategoryCollection === null || pageGenericCategoryCollection === void 0 ? void 0 : (_pageGenericCategoryC = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC === void 0 ? void 0 : _pageGenericCategoryC.description.json) || null;
    });
    var bannerBackgroundImage = computed(function () {
      var _pageGenericCategoryC2, _pageGenericCategoryC3;
      return (pageGenericCategoryCollection === null || pageGenericCategoryCollection === void 0 ? void 0 : (_pageGenericCategoryC2 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC2 === void 0 ? void 0 : (_pageGenericCategoryC3 = _pageGenericCategoryC2.bannerBackgroundImage) === null || _pageGenericCategoryC3 === void 0 ? void 0 : _pageGenericCategoryC3.url) || null;
    });
    var relatedRecipes = computed(function () {
      var _pageGenericCategoryC4, _pageGenericCategoryC5, _pageGenericCategoryC6;
      return (_pageGenericCategoryC4 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC4 === void 0 ? void 0 : (_pageGenericCategoryC5 = _pageGenericCategoryC4.associatedRecipes) === null || _pageGenericCategoryC5 === void 0 ? void 0 : (_pageGenericCategoryC6 = _pageGenericCategoryC5.listOfRecipesCollection) === null || _pageGenericCategoryC6 === void 0 ? void 0 : _pageGenericCategoryC6.items.map(function (item) {
        var _item$carouselCollect;
        return {
          recipeId: item.sys.id,
          slug: item.slug,
          title: item.title,
          cover: (_item$carouselCollect = item.carouselCollection.items[0]) === null || _item$carouselCollect === void 0 ? void 0 : _item$carouselCollect.url
        };
      });
    });
    var relatedProductsContent = computed(function () {
      var _pageGenericCategoryC7, _pageGenericCategoryC8, _pageGenericCategoryC9, _pageGenericCategoryC0;
      return {
        listOfProducts: (_pageGenericCategoryC7 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC7 === void 0 ? void 0 : (_pageGenericCategoryC8 = _pageGenericCategoryC7.associatedProducts) === null || _pageGenericCategoryC8 === void 0 ? void 0 : _pageGenericCategoryC8.listOfProducts,
        description: (_pageGenericCategoryC9 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC9 === void 0 ? void 0 : (_pageGenericCategoryC0 = _pageGenericCategoryC9.associatedProducts) === null || _pageGenericCategoryC0 === void 0 ? void 0 : _pageGenericCategoryC0.description
      };
    });
    var relatedAdvices = computed(function () {
      var _pageGenericCategoryC1, _pageGenericCategoryC10, _pageGenericCategoryC11;
      return (_pageGenericCategoryC1 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC1 === void 0 ? void 0 : (_pageGenericCategoryC10 = _pageGenericCategoryC1.associatedAdvices) === null || _pageGenericCategoryC10 === void 0 ? void 0 : (_pageGenericCategoryC11 = _pageGenericCategoryC10.advicesCollection) === null || _pageGenericCategoryC11 === void 0 ? void 0 : _pageGenericCategoryC11.items;
    });
    var sectionCollection = computed(function () {
      var _pageGenericCategoryC12, _pageGenericCategoryC13, _pageGenericCategoryC14;
      return (_pageGenericCategoryC12 = (_pageGenericCategoryC13 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC13 === void 0 ? void 0 : (_pageGenericCategoryC14 = _pageGenericCategoryC13.sectionCollection) === null || _pageGenericCategoryC14 === void 0 ? void 0 : _pageGenericCategoryC14.items) !== null && _pageGenericCategoryC12 !== void 0 ? _pageGenericCategoryC12 : [];
    });
    var seoMeta = useState('category-content-seo', function () {
      return null;
    });
    var tilesList = function tilesList(section) {
      var _section$tilesCollect, _section$tilesCollect2;
      return (_section$tilesCollect = section === null || section === void 0 ? void 0 : (_section$tilesCollect2 = section.tilesCollection) === null || _section$tilesCollect2 === void 0 ? void 0 : _section$tilesCollect2.items) !== null && _section$tilesCollect !== void 0 ? _section$tilesCollect : [];
    };
    var categorySlug = computed(function () {
      var _pageGenericCategoryC15;
      return ((_pageGenericCategoryC15 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC15 === void 0 ? void 0 : _pageGenericCategoryC15.slug) || '';
    });
    var ourSelection = computed(function () {
      var _pageGenericCategoryC16;
      return ((_pageGenericCategoryC16 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC16 === void 0 ? void 0 : _pageGenericCategoryC16.ourSelections) || undefined;
    });
    var breadcrumbs = computed(function () {
      var _pageGenericCategoryC17;
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: translate('utils.homeBreadcrumbs')
      }, {
        link: app.localePath("/category/".concat(categorySlug.value)),
        text: (_pageGenericCategoryC17 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC17 === void 0 ? void 0 : _pageGenericCategoryC17.title
      }];
    });
    useLazyAsyncData('page-genericCategory', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _pageGenericCategoryC18, _pageGenericCategoryC19;
      var seoFallback, seo;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.contentful.getPageGenericCategory.query({
              locale: locale,
              slug: route.params.slug
            });
          case 2:
            contentResource.value = _context.sent;
            seoFallback = {
              title: (_pageGenericCategoryC18 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC18 === void 0 ? void 0 : _pageGenericCategoryC18.title
            };
            seo = _objectSpread(_objectSpread(_objectSpread({}, seoFallback), pageGenericCategoryCollection === null || pageGenericCategoryCollection === void 0 ? void 0 : (_pageGenericCategoryC19 = pageGenericCategoryCollection.value) === null || _pageGenericCategoryC19 === void 0 ? void 0 : _pageGenericCategoryC19.seo), {}, {
              slug: transformSlugsForSeo(pageGenericCategoryCollection.value)
            });
            setMeta(seo);
            seoMeta.value = getMeta();
            if (pageGenericCategoryCollection.value) {
              _context.next = 10;
              break;
            }
            error({
              statusCode: 404
            });
            return _context.abrupt("return", true);
          case 10:
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Category_Page']);
      window.scrollTo(0, 0);
    });
    setDynamicYieldContextSSR('OTHER', ['Category_Page']);
    return {
      __sfc: true,
      OurSelectionGraphql: OurSelectionGraphql,
      GenericCategoryItemGraphql: GenericCategoryItemGraphql,
      route: route,
      error: error,
      app: app,
      locale: locale,
      setMeta: setMeta,
      getMeta: getMeta,
      client: client,
      translate: translate,
      transformSlugsForSeo: transformSlugsForSeo,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      contentResource: contentResource,
      pageGenericCategoryCollection: pageGenericCategoryCollection,
      description: description,
      bannerBackgroundImage: bannerBackgroundImage,
      relatedRecipes: relatedRecipes,
      relatedProductsContent: relatedProductsContent,
      relatedAdvices: relatedAdvices,
      sectionCollection: sectionCollection,
      seoMeta: seoMeta,
      tilesList: tilesList,
      categorySlug: categorySlug,
      ourSelection: ourSelection,
      breadcrumbs: breadcrumbs,
      AzBackToTopButton: AzBackToTopButton,
      AppCategoriesHeader: AppCategoriesHeader,
      RelatedProductsOrganism: RelatedProductsOrganism,
      RelatedRecipesOrganism: RelatedRecipesOrganism,
      RelatedAdvicesOrganism: RelatedAdvicesOrganism
    };
  }
}));